import { Opt } from '@application/Types/Opt'
import { getVisitorUuidCookies } from '@infrastructure/Cookies'
import { sendGa4EventToGtm } from '@infrastructure/GoogleTagManager'

export type GrowthbookExperimentViewed = {
    event: 'ga4Event'
    event_name: 'growthbook_experiment_viewed'
    event_category: 'experiment'
    experiment_id: string
    variation_id: string
    gb_user_id: Opt<string>
}
export const sendGrowthExperiment = (experimentId: string, variationId: string): void => {
    const visitorUuid = getVisitorUuidCookies()

    const ga4Event: GrowthbookExperimentViewed = {
        event: 'ga4Event',
        event_name: 'growthbook_experiment_viewed',
        event_category: 'experiment',
        experiment_id: experimentId,
        variation_id: variationId,
        gb_user_id: visitorUuid,
    }

    sendGa4EventToGtm(ga4Event)
}
